import { useQuery } from '@tanstack/react-query';
import { systemUserQueries } from '../api/system-user-queries';
import type { SystemUserListParams } from '../lib/system-user-mappers';

/** Paginated staff identities with role/status filters. */
export function useSystemUsers(params: SystemUserListParams, enabled = true) {
  return useQuery(systemUserQueries.list(params, enabled));
}

/** Identity card for the detail modal. */
export function useSystemUserDetail(id: string, enabled = true) {
  return useQuery(systemUserQueries.detail(id, enabled));
}

/** Login sessions for the detail modal. */
export function useSystemUserSessions(
  id: string,
  includeRevoked = false,
  enabled = true,
) {
  return useQuery(systemUserQueries.sessions(id, includeRevoked, enabled));
}
